import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Department of Sports</h1>
                <p>Home &gt; Department of Sports</p>
            </div>
        </div>
    )
}

export default Hero;